import { OnlineAffiliatesPageTemplate } from "./template";

export const OnlineAffiliatesPage = (): JSX.Element => {
  return <OnlineAffiliatesPageTemplate />;
};
